module.exports = __webpack_public_path__ + "static/img/icon-nfs-action.ba89ee9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-nfs-action.svg
// module id = 155
// module chunks = 1